module.exports = __webpack_public_path__ + "static/img/minicons1.e326f217.png";